import {ICsvInterceptor} from '../../core/csv/csv-interceptor';

export class OrderCsvInterceptor implements ICsvInterceptor {
  transform(item: any) {
    let copy = Object.assign({}, item);
    copy.services = item.services ? item.services.length : '';
    return copy;
  }
}
